/* bf-catalog.js — BF mobile redesign (2026-09). Stream file; gate every behaviour on BF.isMobile(). Loaded deferred after bf-core.js. */
(function () {
  "use strict";
  if (!window.BF) return;

  var BF = window.BF;
  var doc = document;

  /* ---------------------------------------------------------------------------
     DOM contract — every selector below is markup C0/C1/C2/C3 render in
     sections/main-collection-new.liquid (or the legacy grid they wrap).

     C5 (Wave 4) renders the SAME contract in sections/main-search.liquid for the
     `/search` results screen — `.bf-toolbar` with `data-bf-total`/`-page`/`-next`
     and `[data-bf-showing]`, a `.collection-products__grid`, a `.bf-loadmore` pill
     and a `[data-bf-sheet="sort"]` sheet — so sort and Load More run here through
     this one Section-Rendering path (one `busy` flag, one `fetchGrid`, one
     `MIN_REQ_MS`). No second fetch path exists anywhere in this file. The only C5
     change to the code below is the `q`-aware `storeKey()` (see there); the sort
     URL and the page URL are already built from `location.search`, so `q` rides
     along on `/search` exactly as `sort_by` does on a collection.

     FIX ROUND C-1 (Phase 3) adds ONE more consumer, the `/collections` landing's
     Best Sellers grid in sections/main-list-collections-new.liquid. Its list is a
     `product_list` section setting, which has no server pagination behind it, so
     there is no `?page=N` for the Section Rendering API to fetch: the section
     renders every batch past the first into an inert `<template>` and the grid
     carries `data-bf-grid="template"`. The ONLY generalisation that needed is
     `nextBatch()` below — one function that returns the same `{nodes,next,page}`
     shape from either source. Everything else (append, `Showing`, replaceState,
     pill visibility, the 320 px auto-load, `busy`, `MIN_REQ_MS`) is the code the
     collection page already runs, unchanged, and `more.client` is false on every
     page that is not the landing, so the collection path is untouched.
     --------------------------------------------------------------------------- */
  var SEL = {
    /* `[data-bf-grid]` only ever exists on the landing; on a collection or search page this
       still resolves to the same `.collection-products__grid` it always did. */
    grid: ".collection-products__grid, [data-bf-grid]",
    card: ".collection-product-card, .bf-card",
    /* likewise `[data-bf-total]` — on a collection/search page it IS the `.bf-toolbar`, so
       `qs()` returns the identical element; the landing has no toolbar and puts the same
       `data-bf-total` / `data-bf-page` attributes on its grid. */
    toolbar: ".bf-toolbar, [data-bf-total]",
    pill: ".bf-toolbar__sort",
    showing: "[data-bf-showing]",
    sheet: '[data-bf-sheet="sort"]',
    opt: ".bf-sort__opt",
    more: "[data-bf-loadmore]",
    moreBtn: "[data-bf-loadmore-btn]",
    tpl: "[data-bf-more-tpl]"
  };

  /* Minimum spacing between two Section Rendering requests, in ms. This is a REQUEST-CADENCE
     rule, not motion: the store sits behind Cloudflare bot protection and a burst of fetches
     (sort taps, or the C3 auto-load chain) can trip a challenge. It also guarantees the
     loading skeletons are on screen long enough to be seen. Not zeroed under reduced motion. */
  var MIN_REQ_MS = 350;

  var busy = false;          // one Section Rendering request in flight at a time (whole file)

  function qs(sel, root) { return (root || doc).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function grid() { return qs(SEL.grid); }
  function toolbar() { return qs(SEL.toolbar); }
  function cards() { var g = grid(); return g ? qsa(SEL.card, g) : []; }
  function attrInt(el, name) { if (!el) return null; var n = parseInt(el.getAttribute(name), 10); return isFinite(n) ? n : null; }
  function total() { var n = attrInt(toolbar(), "data-bf-total"); return n === null ? cards().length : n; }

  /* `Showing N of M` (D4 §5.2 format, no comma separators). N = cards now in the grid. */
  function setShowing(n) {
    var el = qs(SEL.showing);
    if (el) el.textContent = "Showing " + n + " of " + total();
  }

  /* the C1 pill renders as `<text node><svg caret>` — replace only the text node */
  function setPill(label) {
    var pill = qs(SEL.pill);
    if (!pill || !label) return;
    var first = pill.firstChild;
    if (first && first.nodeType === 3) first.nodeValue = label;
    else pill.insertBefore(doc.createTextNode(label), pill.firstChild);
    pill.setAttribute("aria-label", "Sort products. Current sort: " + label);
  }

  /* ---- loading skeletons (D4 §5.5: always exactly 4, square radius 10 + two bars) ---- */
  function skeletons(n) {
    var frag = doc.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var card = doc.createElement("div");
      card.className = "bf-skelcard";
      card.setAttribute("data-bf-skel", "");
      card.setAttribute("aria-hidden", "true");
      card.innerHTML =
        '<span class="bf-skeleton bf-skelcard__sq"></span>' +
        '<span class="bf-skelcard__bar bf-skelcard__bar--a"></span>' +
        '<span class="bf-skelcard__bar bf-skelcard__bar--b"></span>';
      frag.appendChild(card);
    }
    return frag;
  }

  function clearSkeletons(root) {
    qsa("[data-bf-skel]", root || doc).forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  /* ---- Section Rendering (CONTRACTS §7): fetch one page/sort and hand back its grid children,
          imported into this document, plus the toolbar attributes the response carries. ---- */
  function fetchGrid(url) {
    var id = BF.sectionIdFromDom();
    if (!id) return Promise.reject(new Error("[BF] no section id in the DOM"));
    var startedAt = Date.now();
    return BF.renderSection(url, id).then(function (root) {
      var g = root.querySelector(SEL.grid);
      var tb = root.querySelector(SEL.toolbar);
      var out = {
        nodes: g ? Array.prototype.slice.call(g.children).map(function (n) { return doc.importNode(n, true); }) : [],
        next: tb ? (tb.getAttribute("data-bf-next") || "") : "",
        page: tb ? attrInt(tb, "data-bf-page") : null,
        total: tb ? attrInt(tb, "data-bf-total") : null,
        empty: !g
      };
      var wait = Math.max(0, MIN_REQ_MS - (Date.now() - startedAt));
      if (!wait) return out;
      return new Promise(function (resolve) { setTimeout(function () { resolve(out); }, wait); });
    });
  }

  /* ===========================================================================
     C2 — sort sheet
     Tap a row -> ?sort_by=<value> through the Section Rendering API, swap the grid
     children in place (no page load), update the pill + `Showing`, replaceState.
     The sheet itself is opened by bf-core.js's declarative `data-bf-open="sort"`.
     =========================================================================== */
  function sheet() { return qs(SEL.sheet); }

  /* C3 hook: reset the Load More state after a sort re-render. Assigned in the C3 block below;
     left null here so C2 stands on its own. */
  var onGridReset = null;

  function markSelected(value) {
    qsa(SEL.opt, sheet()).forEach(function (o) {
      var on = o.getAttribute("data-bf-sort") === value;
      o.classList.toggle("is-selected", on);
      o.setAttribute("aria-checked", on ? "true" : "false");
      if (on) o.setAttribute("data-bf-autofocus", "");
      else o.removeAttribute("data-bf-autofocus");
    });
  }

  function selectedSort() {
    var on = qs(SEL.opt + ".is-selected", sheet());
    return on ? on.getAttribute("data-bf-sort") : null;
  }

  function sortUrl(value) {
    var p = new URLSearchParams(location.search);
    p.set("sort_by", value);
    p.delete("page");
    return location.pathname + "?" + p.toString();
  }

  function applySort(value, label) {
    if (!value || busy || !BF.isMobile()) return;
    var g = grid();
    /* empty collection (no grid at all, D4 §5.7): nothing to swap — let the browser navigate */
    if (!g) { BF.closeSheet("sort"); location.href = sortUrl(value); return; }

    var prevValue = selectedSort();
    var prevLabel = (function () { var o = qs('[data-bf-sort="' + prevValue + '"]', sheet()); return o ? o.getAttribute("data-bf-sort-label") : null; })();
    if (value === prevValue) { BF.closeSheet("sort"); return; }

    var url = sortUrl(value);
    var keep = Array.prototype.slice.call(g.children);

    markSelected(value);
    setPill(label);
    BF.closeSheet("sort");                    /* the prototype closes in the same tick (§18.1) */

    busy = true;
    g.innerHTML = "";
    g.appendChild(skeletons(4));

    fetchGrid(url).then(function (res) {
      g.innerHTML = "";
      res.nodes.forEach(function (n) { g.appendChild(n); });
      setShowing(cards().length);
      try { history.replaceState(null, "", url); } catch (e) { /* noop */ }
      if (typeof onGridReset === "function") onGridReset(res);
      BF.emit("bf:catalog:sorted", { sort: value, url: url });
    }).catch(function (err) {
      /* leave the shopper exactly where they were: restore the old cards, pill and radio */
      g.innerHTML = "";
      keep.forEach(function (n) { g.appendChild(n); });
      if (prevValue) markSelected(prevValue);
      if (prevLabel) setPill(prevLabel);
      setShowing(cards().length);
      if (window.console) console.warn("[BF] sort failed", err && err.message);
    }).then(function () { busy = false; });
  }

  function initSort() {
    var el = sheet();
    if (!el) return;

    el.addEventListener("click", function (e) {
      var opt = e.target && e.target.closest ? e.target.closest(SEL.opt) : null;
      if (!opt || !el.contains(opt)) return;
      e.preventDefault();
      applySort(opt.getAttribute("data-bf-sort"), opt.getAttribute("data-bf-sort-label") || (opt.textContent || "").trim());
    });

    /* radiogroup keyboard convention: Up/Down move between rows (Tab is trapped by core) */
    el.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
      var opts = qsa(SEL.opt, el);
      var i = opts.indexOf(doc.activeElement);
      if (i === -1) return;
      e.preventDefault();
      opts[(i + (e.key === "ArrowDown" ? 1 : opts.length - 1)) % opts.length].focus();
    });
  }

  /* ===========================================================================
     C3 — Load More
     Mobile-only pill under the grid (legacy numbered pagination stays in the DOM,
     hidden <= 749 px since C1). Fetch `?page=N` through the Section Rendering API,
     append the next page's cards, update `Showing N of M`, replaceState `?page=N`,
     auto-load within 320 px of the bottom, and restore the page count + scroll
     position on a return visit. Batch = the server page (12), per the BUILD-MAP
     deviation; the prototype's +4 batches are not reproducible against Shopify's
     pagination without over-fetching.
     =========================================================================== */
  var MAX_RESTORE_FETCHES = 6;                 /* hard cap on the restore chain (cadence) */
  var STALE_MS = 30 * 60 * 1000;               /* stored page count expires after 30 min */

  var more = { page: 1, next: "", io: null, chain: false, client: false, step: 4 };

  function moreWrap() { return qs(SEL.more); }
  function moreBtn() { return qs(SEL.moreBtn); }

  /* ---- C-1: the landing's batch source ------------------------------------------------
     `<template>` content is an inert DocumentFragment: it is never laid out and its images
     are never requested, so the whole pool can be rendered server-side at no cost until a
     batch is taken out of it. Taking a batch REMOVES those cards from the fragment, so the
     fragment's remaining child count is "is there a next batch". */
  function tpl() { return qs(SEL.tpl); }
  function tplRemaining() { var t = tpl(); return t ? t.content.childElementCount : 0; }

  function tplTake(n) {
    var t = tpl(), out = [];
    if (!t) return out;
    while (out.length < n) {
      var el = t.content.firstElementChild;
      if (!el) break;
      out.push(doc.importNode(el, true));
      t.content.removeChild(el);
    }
    return out;
  }

  /* One source of truth for "the next batch", in fetchGrid()'s exact shape: a Section
     Rendering request on a collection or search page, a slice of the landing's <template>
     on /collections. The client slice still waits out MIN_REQ_MS so the loading skeletons
     are on screen for the same beat either way. */
  function nextBatch(n) {
    if (!more.client) return fetchGrid(pageUrl(n));
    var startedAt = Date.now();
    var nodes = tplTake(more.step);
    var out = { nodes: nodes, next: tplRemaining() ? pageUrl(n + 1) : "", page: n, total: null, empty: false };
    var wait = Math.max(0, MIN_REQ_MS - (Date.now() - startedAt));
    return new Promise(function (resolve) { setTimeout(function () { resolve(out); }, wait); });
  }

  function pageUrl(n) {
    var p = new URLSearchParams(location.search);   /* carries sort_by, filters, everything */
    if (n > 1) p.set("page", String(n)); else p.delete("page");
    var q = p.toString();
    return location.pathname + (q ? "?" + q : "");
  }

  function showMore(on) {
    var w = moreWrap();
    if (!w) return;
    w.hidden = !on;
    if (!on && more.io) { more.io.disconnect(); more.io = null; }
    else if (on) observeMore();
  }

  function setMoreBusy(on) {
    var b = moreBtn();
    if (!b) return;
    b.disabled = !!on;
    b.setAttribute("aria-busy", on ? "true" : "false");
  }

  /* ---- one page fetch + append ---- */
  function loadNext(opts) {
    opts = opts || {};
    var g = grid();
    if (busy || more.chain || !more.next || !g || !BF.isMobile()) return Promise.resolve(false);

    var n = more.page + 1;
    var url = pageUrl(n);
    busy = true;
    setMoreBusy(true);
    g.appendChild(skeletons(4));

    return nextBatch(n).then(function (res) {
      clearSkeletons(g);
      res.nodes.forEach(function (node) { g.appendChild(node); });
      more.page = res.page || n;
      more.next = res.next;
      setShowing(cards().length);
      try { history.replaceState(null, "", url); } catch (e) { /* noop */ }
      showMore(!!more.next);
      persist();
      BF.emit("bf:catalog:loaded", { page: more.page, url: url, cards: cards().length });
      return true;
    }).catch(function (err) {
      clearSkeletons(g);
      if (window.console) console.warn("[BF] load more failed", err && err.message);
      return false;
    }).then(function (ok) {
      busy = false;
      setMoreBusy(false);
      /* an IntersectionObserver only re-fires on a state CHANGE; if the pill is still inside
         the 320 px margin after the append, keep the chain going on a timer instead. */
      if (ok && opts.auto) setTimeout(autoIfNear, MIN_REQ_MS);
      return ok;
    });
  }

  /* ORR2 publish-prep: 320 -> PREFETCH_PX. Measured cause of the /collections CLS of 0.4048:
     with a 320 px margin the append fired while the pill and the footer were still ON SCREEN
     (Layout Instability sources recorded the pill at y 567 in a 664 px viewport, going to h 0),
     so inserting cards pushed both out of view and every one of those pixels counted. Firing a
     full viewport-and-a-bit earlier puts the pill and footer off-screen at append time, where a
     shift has ~0 impact fraction. This does not change WHAT loads, only WHEN. */
  var PREFETCH_PX = 800;

  function nearBottom() {
    var w = moreWrap();
    if (!w || w.hidden) return false;
    var r = w.getBoundingClientRect();
    return r.top - (window.innerHeight || 0) < PREFETCH_PX;
  }

  function autoIfNear() {
    if (!busy && !more.chain && more.next && BF.isMobile() && nearBottom()) loadNext({ auto: true });
  }

  function observeMore() {
    var w = moreWrap();
    if (!w || w.hidden || !("IntersectionObserver" in window)) return;
    if (more.io) more.io.disconnect();
    more.io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadNext({ auto: true }); return; }
      }
    }, { root: null, rootMargin: PREFETCH_PX + "px", threshold: 0 });
    more.io.observe(w);
  }

  /* ---- session state: how far the shopper had scrolled this collection ---- */
  /* C5: `/search` serves every query from one pathname, so the key carries `q` when there is
     one. Collection pages have no `q`, so their key is byte-identical to C3's. */
  function storeKey() {
    var q = null;
    try { q = new URLSearchParams(location.search).get("q"); } catch (e) { /* noop */ }
    return "bf:scroll:" + location.pathname + (q ? "?q=" + q : "");
  }

  function readStore() {
    try {
      var raw = sessionStorage.getItem(storeKey());
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function persist(scrollY) {
    try {
      var prev = readStore() || {};
      sessionStorage.setItem(storeKey(), JSON.stringify({
        page: more.page,
        scrollY: typeof scrollY === "number" ? scrollY : (prev.scrollY || 0),
        t: Date.now()
      }));
    } catch (e) { /* noop */ }
  }

  function navType() {
    try {
      var e = performance.getEntriesByType("navigation")[0];
      if (e && e.type) return e.type;
      if (performance.navigation) return performance.navigation.type === 2 ? "back_forward" : "navigate";
    } catch (e) { /* noop */ }
    return "navigate";
  }

  /* fetch a list of page numbers strictly one at a time (fetchGrid holds each call open for
     at least MIN_REQ_MS, so consecutive requests are >= 350 ms apart) */
  function fetchSeq(pages) {
    return pages.reduce(function (chain, n) {
      return chain.then(function (acc) {
        return fetchGrid(pageUrl(n)).then(function (res) { acc.push({ page: n, res: res }); return acc; });
      });
    }, Promise.resolve([]));
  }

  function appendAll(g, list, prepend) {
    if (!list.length) return;
    var frag = doc.createDocumentFragment();
    list.forEach(function (it) { it.res.nodes.forEach(function (n) { frag.appendChild(n); }); });
    if (prepend) g.insertBefore(frag, g.firstChild); else g.appendChild(frag);
  }

  /* ---- restore on a back/forward navigation or a reload ----
     Only those two navigation types rebuild. The prototype keeps `shown` across ANY navigation
     (D4 §5.3: "`go()` does not clear `state.shown` … reproduce or fix deliberately") — fixed
     deliberately here, because on this store every rebuilt page is a live Section Rendering
     request and re-fetching them when a shopper simply re-enters the collection from the menu
     would burn requests against the Cloudflare cap for content they did not ask for. */
  function restore(serverPage) {
    var type = navType();
    if (type !== "back_forward" && type !== "reload") return;
    var s = readStore();
    if (!s || !s.page || s.page < 2) return;
    if (Date.now() - (s.t || 0) > STALE_MS) return;
    var g = grid();
    if (!g) return;

    /* C-1: the landing's batches are already in the document — reveal them in one pass, with
       no requests at all. (This branch is also a HARD guard: the fetch chain below would ask
       for `/collections?page=2`, which renders the whole landing section again and would
       append the entire pool a second time.) */
    if (more.client) {
      var want = (s.page - more.page) * more.step;
      if (want <= 0) return;
      tplTake(want).forEach(function (n) { g.appendChild(n); });
      more.page = s.page;
      more.next = tplRemaining() ? pageUrl(more.page + 1) : "";
      setShowing(cards().length);
      try { history.replaceState(null, "", pageUrl(more.page)); } catch (e) { /* noop */ }
      showMore(!!more.next);
      persist();
      if (typeof s.scrollY === "number") window.scrollTo(0, s.scrollY);
      return;
    }

    /* the server rendered exactly page `serverPage`; rebuild pages 1..s.page around it */
    var target = Math.min(s.page, serverPage + MAX_RESTORE_FETCHES);
    var before = [];
    for (var i = 1; i < serverPage && before.length < MAX_RESTORE_FETCHES; i++) before.push(i);
    var after = [];
    for (var j = serverPage + 1; j <= target; j++) after.push(j);
    if (!before.length && !after.length) return;

    var wantScroll = typeof s.scrollY === "number" ? s.scrollY : null;

    more.chain = true;
    setMoreBusy(true);
    g.appendChild(skeletons(4));

    fetchSeq(before).then(function (list) {
      appendAll(g, list, true);
      return fetchSeq(after);
    }).then(function (list) {
      appendAll(g, list, false);
      if (list.length) {
        var last = list[list.length - 1];
        more.page = last.res.page || last.page;
        more.next = last.res.next;
      }
    }).catch(function (err) {
      if (window.console) console.warn("[BF] scroll restore failed", err && err.message);
    }).then(function () {
      clearSkeletons(g);
      more.chain = false;
      setMoreBusy(false);
      setShowing(cards().length);
      try { history.replaceState(null, "", pageUrl(more.page)); } catch (e) { /* noop */ }
      showMore(!!more.next);
      persist();
      if (wantScroll !== null) window.scrollTo(0, wantScroll);
    });
  }

  function initMore() {
    var g = grid();
    var tb = toolbar();
    /* C-1: `data-bf-grid="template"` is the landing's grid and nothing else in the theme
       carries it, so `more.client` is false on every other screen. */
    more.client = !!(g && g.getAttribute("data-bf-grid") === "template" && tpl());
    more.step = attrInt(g, "data-bf-step") || 4;
    var serverPage = attrInt(tb, "data-bf-page") || 1;
    more.page = serverPage;
    more.next = more.client
      ? (tplRemaining() ? pageUrl(serverPage + 1) : "")
      : (tb ? (tb.getAttribute("data-bf-next") || "") : "");

    var btn = moreBtn();
    if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); loadNext(); });

    /* after a sort re-render the grid is page 1 again */
    onGridReset = function (res) {
      more.page = res.page || 1;
      more.next = res.next;
      showMore(!!more.next);
      persist();
    };

    window.addEventListener("pagehide", function () { persist(Math.round(window.scrollY || 0)); });
    window.addEventListener("pageshow", function (e) {
      /* bfcache restore: the DOM, `more` and the observer all survived — the browser puts the
         scroll position back itself, so there is nothing to rebuild. */
      if (!e.persisted) return;
      showMore(!!more.next);
    });

    showMore(!!more.next);

    /* a direct hit on ?page=N (a shared link, no session state) renders only that page's cards,
       but C1's Liquid always prints the full page size — re-state `Showing` from the DOM. */
    if (serverPage > 1) setShowing(cards().length);

    restore(serverPage);
  }

  /* ---- boot ---- */
  BF.ready(function () {
    if (!sheet() && !grid()) return;           /* not a collection page */
    initSort();
    initMore();
  });
})();
